Text of the question displayed to the candidate.
